"use client"
import React from "react"
import Image from "next/image"

import { qualifyImageUrl } from "@/lib/formatters/formatImages"
import { SimpleCarousel } from "@/components/terra/component/SimpleCarousel/SimpleCarousel"

interface ImageCarouselProps {
  items: object[]
}

const ImageCarousel: React.FC<ImageCarouselProps> = ({ items }) => {
  return (
    <div className="mb-2">
      <SimpleCarousel>
        {items.map((item: any) => {
          const imageUrl = qualifyImageUrl(`${item.url}`, 1200, 600)
          if (!imageUrl || imageUrl == "") {
            return null
          }
          return (
            <div key={item.sys.id}>
              <Image
                src={imageUrl}
                width={1200}
                height={600}
                alt={item.description || ""}
              />
            </div>
          )
        })}
      </SimpleCarousel>
    </div>
  )
}

export default ImageCarousel
